/* Alberenz homepage behaviour: hero slider, mobile rails, collection tabs.
   No dependencies. Every widget initialises itself from data attributes so the
   theme editor can add/remove sections without a page reload breaking things. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 760px)';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Hero slider ─────────────────────────────────────────── */
  function hero(root) {
    if (root.dataset.albInit) return;
    root.dataset.albInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.alb-hero-slide'));
    var copies = Array.prototype.slice.call(root.querySelectorAll('.alb-hero-copy'));
    /* De besturing staat per slide in de markup (zie de sectie), dus er zijn
       evenveel stipjesgroepen als slides. Ze worden allemaal bijgewerkt, en een
       klik telt binnen de eigen groep. */
    var groups = Array.prototype.slice.call(root.querySelectorAll('.alb-hero-dots'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.alb-hero-dots button'));
    var n = slides.length;
    if (n < 2) return;

    var delay = parseInt(root.dataset.interval, 10) || 6500;
    var i = 0;
    var hold = false;
    var timer = null;

    function show(next) {
      i = (next + n) % n;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      copies.forEach(function (c, idx) { c.hidden = idx !== i; });
      groups.forEach(function (g) {
        Array.prototype.forEach.call(g.children, function (d, idx) {
          d.classList.toggle('is-active', idx === i);
          d.setAttribute('aria-current', idx === i ? 'true' : 'false');
        });
      });
      root.classList.toggle('is-bright', slides[i].classList.contains('is-bright'));
    }

    function start() {
      stop();
      if (hold || reduced) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(Array.prototype.indexOf.call(d.parentNode.children, d));
        start();
      });
    });
    root.querySelectorAll('[data-alb-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); start(); });
    });
    root.querySelectorAll('[data-alb-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); start(); });
    });

    root.addEventListener('mouseenter', function () { hold = true; stop(); });
    root.addEventListener('mouseleave', function () { hold = false; start(); });

    /* swipe: horizontal only, so vertical page scroll keeps working */
    var x0 = null;
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; hold = true; stop(); });
    root.addEventListener('pointerup', function (e) {
      var x = x0; x0 = null; hold = false;
      if (x !== null) {
        var dx = e.clientX - x;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      }
      start();
    });
    root.addEventListener('pointercancel', function () { x0 = null; hold = false; start(); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  /* ── Mobile rails: derive dot indicators from scroll position ─ */
  function rail(el) {
    if (el.dataset.albInit) return;
    el.dataset.albInit = '1';

    var dots = el.parentNode.querySelector('.alb-dots');
    if (!dots) return;
    var items = dots.querySelectorAll('span');
    var count = items.length;
    if (!count) return;

    var raf = null;
    el.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (!window.matchMedia(MOBILE).matches) return;
        var stride = el.scrollWidth / count;
        var act = Math.max(0, Math.min(count - 1, Math.round(el.scrollLeft / stride)));
        for (var k = 0; k < count; k++) items[k].classList.toggle('is-active', k === act);
      });
    }, { passive: true });
  }

  /* ── Collection tabs ─────────────────────────────────────── */
  function tabs(root) {
    if (root.dataset.albInit) return;
    root.dataset.albInit = '1';

    var btns = Array.prototype.slice.call(root.querySelectorAll('.alb-tabs button'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('aria-controls');
        btns.forEach(function (o) {
          var on = o === b;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.setAttribute('tabindex', on ? '0' : '-1');
        });
        root.querySelectorAll('.alb-panel').forEach(function (p) {
          p.hidden = p.id !== id;
        });
      });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var nxt = btns[(btns.indexOf(b) + d + btns.length) % btns.length];
        nxt.focus();
        nxt.click();
      });
    });
  }

  /* ── Add to cart (product cards + clip rows) ─────────────── */
  /* Toevoegen zonder de pagina te verlaten. Dit thema heeft geen cart-drawer,
     dus eerder sprong je na elke toevoeging naar /cart. Wie drie dingen uit één
     clip wilde, moest dus drie keer terugnavigeren. Nu blijft de bezoeker staan,
     werkt de teller in de header bij en bevestigt de knop zelf. */
  function refreshBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#shopify-section-cart-icon-bubble');
        var target = document.querySelector('#cart-icon-bubble');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function confirmAdded(btn) {
    var label = btn.querySelector('[data-alb-label]');
    var added = btn.getAttribute('data-added-label');
    if (label && added && !label.dataset.original) {
      label.dataset.original = label.textContent;
      label.textContent = added;
    }
    btn.setAttribute('data-alb-added', '');
    clearTimeout(btn._albTimer);
    btn._albTimer = setTimeout(function () {
      btn.removeAttribute('data-alb-added');
      if (label && label.dataset.original) {
        label.textContent = label.dataset.original;
        delete label.dataset.original;
      }
    }, 2200);
  }

  function cart(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-alb-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-alb-add');
      if (!id) return;

      btn.disabled = true;
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.disabled = false;
          confirmAdded(btn);
          refreshBubble();
          /* Voor het thema en apps die op de winkelwagen meeluisteren. */
          document.dispatchEvent(new CustomEvent('alb:cart:added', { detail: { id: id } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          btn.disabled = false;
          /* Lukt toevoegen niet, dan is de productpagina de eerlijkste uitweg. */
          var href = btn.getAttribute('data-alb-href');
          if (href) window.location.href = href;
        });
    });
  }


  /* ── Video: poster nu, player pas bij een klik ───────────── */
  function videoFacade(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-alb-video]');
      if (!btn) return;
      var url = btn.getAttribute('data-alb-video');
      var frame = document.createElement('iframe');
      /* Mux negeert autoplay=1; alleen 'any', 'muted' of 'true' worden herkend.
         'any' probeert eerst met geluid en valt terug op gedempt, zodat de clip
         hoe dan ook meteen speelt en de bezoeker niet twee keer hoeft te klikken.
         De browser blokkeert geluid in een iframe omdat de klik buiten dat frame
         plaatsvond, dus in de praktijk start hij gedempt met de knop om aan te zetten. */
      frame.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=any';
      frame.title = btn.getAttribute('aria-label') || '';
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      frame.setAttribute('allowfullscreen', '');
      btn.parentNode.replaceChild(frame, btn);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-alb-hero]').forEach(hero);
    (scope || document).querySelectorAll('.alb-rail').forEach(rail);
    (scope || document).querySelectorAll('[data-alb-tabs]').forEach(tabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); cart(document); videoFacade(document); });
  } else {
    init();
    cart(document);
    videoFacade(document);
  }

  /* theme editor: re-init a section after it is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
